import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { ModalDismissReasons, NgbDatepickerModule, NgbModal, NgbOffcanvas, NgbModalRef, NgbOffcanvasRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { UsersService } from 'src/app/private/services/users.service';
import { ContactGrouopService } from 'src/app/private/services/contact-groups.service';
import { SequenceService } from 'src/app/private/services/sequence.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { Router } from '@angular/router';
import { TrackingService } from 'src/app/private/services/tracking.service';


@Component({
  selector: 'app-sequences',
  templateUrl: './sequences.component.html',
  styleUrls: ['./sequences.component.scss']
})

export class SequencesComponent {
  private addSequence: NgbModalRef | null = null;
  private addSschedule: NgbOffcanvasRef | null = null;
  private modalRef!: NgbModalRef;
  [x: string]: any;
  isLoading = false;
  slelectLoading = true;
  totalRows = 0;
  pageSize = 50;
  currentPage = 0;
  pageSizeOptions: number[] = [10, 25, 50];
  dataSource: any[] = [];
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  formAction = 'add'
  displayedColumns: string[] = ["status", "name", "active", "paused", "not_sent", "sent", "delivery", "open", "date", "action"]
  user: User = new User();
  @ViewChild("userForm")
  userForm!: NgForm;
  isSubmitted: boolean = false
  centers: any;
  roles: any;
  dateQuery = new FormControl();
  departmentsList: any;
  allUsers: any = [];
  deleteParam: any = {};
  newPassword: any = "";
  selectedRecord: any = {};
  contactGroups: any = {};
  filterArray: any = [
    { key: 'name', value: 'Name' },
    { key: 'sequence_status', value: 'Status' }
  ];
  signatures: string[] = []; // List of signatures
  selectedIndex: number | null = null; // Currently selected signature index
  initialLoad: boolean = true;
  schedules: any = [];
  schedule_name = "";
  sunday_first = "";
  sunday_second = "";
  monday_first = "";
  monday_second = "";
  tuesday_first = "";
  tuesday_second = "";
  wednesday_first = "";
  wednesday_second = "";
  thursday_first = "";
  thursday_second = "";
  friday_first = "";
  friday_second = "";
  saturday_first = "";
  saturday_second = "";
  sequence_name = "";
  new_sequence_name = "";
  sequence_schedule = "";
  new_sequence_schedule = "";
  new_sequence: any = {};
  selected_schedule: any;
  isLoadingSchedule = false;
  communication_preference:boolean = false
  communication_preference_data :any;

  schedule_error: string = "";

  emailProviders: any = [
  ];

  email_provider_type = "OUTLOOK";
  initialLoading: boolean = true;

  needToConnectOutlook: boolean = false;
  needToConnectSes: boolean = false;

  needToConnectEmail: boolean = false;

  showOutlook: boolean = false;
  showDomainAuth: boolean = false;

  sesDetails: any = {};
  isAdmin: boolean = false;
@ViewChild('emailConfirm') emailConfirmModal!: TemplateRef<any>;
  constructor(private tracker: TrackingService, private router: Router, private toast: ToastrService, private offcanvasService: NgbOffcanvas, private api: UsersService, private sequenceApi: SequenceService, private contactApi: ContactGrouopService, private modalService: NgbModal, private localStorage: LocalStorageService) {

     this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );

  }

  ngOnInit(): void {

    let permissions = this.localStorage.getPermissions();

     const commPref = this.localStorage.getCommincationPref();
     console.log("commPref",commPref)

      const isInvalidPref =
        !commPref ||
        typeof commPref !== 'object' ||
        !commPref.email ||
        !commPref.provider;

         if (isInvalidPref) {
          this.communication_preference = false
         }
         else {
          this.communication_preference_data = commPref
          this.communication_preference = true
         }
      

    // ✅ Ensure permissions is an array
    if (typeof permissions === 'string') {
      permissions = JSON.parse(permissions);
    }

    const hasMailHub = permissions?.some((module: any) =>
      module.module_name === 'sales-mail-hub' && module.active
    );

    const hasDomainAuth = permissions?.some((module: any) =>
      module.module_name === 'setting' &&
      module.features?.some((f: any) => f.name === 'domain_authentication' && f.active)
    );

    this.showOutlook = hasMailHub;
    this.showDomainAuth = hasDomainAuth;

    //this.getAllUsers();
    this.getEmailConnection();
  }

 
   handleOpenCommunicationDialog() {

    const commPref = this.localStorage.getCommincationPref();
 

      const isInvalidPref =
        !commPref ||
        typeof commPref !== 'object' ||
        !commPref.email ||
        !commPref.provider;

      if (isInvalidPref) {
        this.modalService.open(this.emailConfirmModal, {
          size: 'md',
          scrollable: true,
          centered: true,
          backdrop: 'static',
          keyboard: false
        });
      } 
  }


  getEmailConnection() {
    let param = {
      client_id: this.localStorage.getClientId(),
      from_email: this.communication_preference_data?.email
    }

    this.sequenceApi.checkForMailConfigConnection(param).subscribe({
      next: (res: any) => {
        console.log("email connection :", res);
        this.email_provider_type = res.provider_type || "OUTLOOK";
        this.initialLoading = false;

        this.needToConnectOutlook = res.outlookMailboxConnection == false ? true : false;
        this.needToConnectSes = res.sesMailboxConnection == false ? true : false;

        const outlookConnected =
          this.needToConnectOutlook === false && this.showOutlook === true;
        const gmailConnected =
          this.localStorage.hasMailboxConnection('gmail') && this.showOutlook === true;

        let providers: string[] = [];
        // Mail Hub: never offer both Outlook and Gmail — only the connected mailbox(es), or active pref if both.
        if (outlookConnected && !gmailConnected) {
          providers.push('OUTLOOK');
        } else if (gmailConnected && !outlookConnected) {
          providers.push('GMAIL');
        } else if (outlookConnected && gmailConnected) {
          const active = this.localStorage.getCommincationPref()?.provider;
          if (active === 'gmail') {
            providers.push('GMAIL');
          } else {
            providers.push('OUTLOOK');
          }
        }

        if (this.needToConnectSes == false && this.showDomainAuth == true) {
          this.sesDetails = res.sesMailboxConnection;
          providers.push('SES');
        }

        this.emailProviders = providers;

        this.needToConnectEmail = providers.length === 0;

        const preferred = this.localStorage.getEmailProviderTypeForPayload();
        if (providers.includes(preferred)) {
          this.email_provider_type = preferred;
        } else if (providers.includes('OUTLOOK')) {
          this.email_provider_type = 'OUTLOOK';
        } else if (providers.includes('GMAIL')) {
          this.email_provider_type = 'GMAIL';
        } else if (providers.includes('SES')) {
          this.email_provider_type = 'SES';
        }




        this.loadAllSequence();
      },
      error: (e) => {
        this.initialLoading = false;
      }
    })
  }

  redirectToOutlook() {
    this.modalService.dismissAll();
    this.router.navigate(['/main/sales-mail-hub']);
  }

  redirectToDomainAuth() {
    this.modalService.dismissAll();
    this.router.navigate(['/main/domain-authentication']);
  }

  getDropdownList() {
    this.api.userModuleDropdownListing().subscribe({
      next: (res) => {
        this.centers = res.centers || []
        this.roles = res.roles || []
        this.departmentsList = res.departments || []
      },
      error: (e) => {

      }
    })
  }

  dateFilter(event: any) {
    this.dateQuery.setValue(event);
  }

  // getAllUsers() {
  //   let param = {
  //     where:{
  //       // center_id:this.localStorage.getCenterId(),
  //       client_id: parseInt(this.localStorage.getClientId())
  //     },
  //   };
  //   this.api.getAllData(param).subscribe({
  //     next: (res : any) => {
  //       this.allUsers = res || [];
  //       console.log(this.allUsers);
  //     },
  //     error: (e:any) => {
  //       console.error(e);
  //     },
  //   });
  // }

  deleteFieldModal(content: any, row: any) {
    this.new_sequence = row;
    let param = {
      ...row,
      status: "Suspended"
    }
    this.deleteParam = param;
    this.modalService.open(content, {
      size: 'l',
      scrollable: true,
      centered: true,
    });
  }

  deleteUser() {
    this.isLoading = true;
    this.api.updateUser(this.deleteParam).subscribe({
      next: (res: any) => {
        this.modalService.dismissAll();
        this.isLoading = false;
        this.toast.success("User Deleted Successfully", "Success");
        this.loadData();
        this.tracker.track(
          'Delete',
          'User',
          `Deleted user ID: ${this.deleteParam.user_id || 'N/A'}`
        );
      },
      error: (e) => {
        this.isLoading = false;
        this.toast.error(e.error.msg, "Error");
      }
    })
  }

  getCenters() {
    let param = {
      where: {
        client_id: this.localStorage.getClientId(),
      }
    }
    this.api.getAllCenter(param).subscribe({
      next: (res) => {
        this.centers = res;
      }
    })
  }

  loadDepartments() {
    let param = {
      where: {
        // center_id:this.localStorage.getCenterId(),
        client_id: this.localStorage.getClientId(),
      }
    }
    this.api.getAllDepartment(param).subscribe({
      next: (res) => {
        this.departmentsList = res;
      }
    })
  }

  loadRoles() {
    let param = {
      where: {
        // center_id: parseInt(this.localStorage.getCenterId()),
        client_id: parseInt(this.localStorage.getClientId())
      }

    }
    this.api.getAllRoles(param).subscribe({
      next: (res) => {
        console.log("role", res)
        this.roles = res;
      }
    })
  }

  ngAfterViewInit() {
    // this.loadAllSequence();
    // this.loadAllSchedule();
  }

  loadData() {
    try {
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      merge(this.searchQuery.valueChanges, this.sort.sortChange, this.paginator.page).pipe(startWith({}),
        switchMap(() => {
          let param = {
            where: {
              // center_id:this.localStorage.getCenterId(),
              client_id: parseInt(this.localStorage.getClientId())
            },
            page: (this.paginator.pageIndex * this.paginator.pageSize),
            limit: this.paginator.pageSize,
            filter: this.searchQuery.value,
            order: {
              col: '"sequence"."updatedAt"',
              dir: 'DESC',
            },
          }
          return this.api.getAllData(param)
            .pipe(catchError(() => observableOf(null)));
        }), map((response: any) => {
          if (response === null) {
            this.initialLoad = false;
            return [];
          }

          this.totalRows = response.count;
          return response
        })
      ).subscribe({
        next: (data) => {
          this.initialLoad = false;
          console.log("Data->rows", data.rows)
        },
        error: (e) => {
          console.error(e)
        },
        complete: () => {
          this.initialLoad = false;
        }
      })
    }
    catch (e) {
      this.isLoading = false;
      console.error(e)
    }
  }
  searchFilter(query: any) {
    this.searchQuery.setValue(query);
  }
  open(content: any) {
    // this.loadAllSchedule();
    setTimeout(() => {

      // setTimeout(() => {
      //   this.loadDepartments();
      //   setTimeout(() => {
      //     this.loadRoles();
      //   }, 1000);
      // }, 1000);
    }, 1000);
    this.user = new User();
    this.formAction = "add";
    this.addSequence = this.modalService.open(content, { size: 'ml', scrollable: true, centered: true })

  }

  onSelect() {
    console.log("index : ", this.sequence_schedule);
    if (this.sequence_schedule) {
      this.selected_schedule = this.schedules[Number(this.sequence_schedule)];
    }
    else {
      this.selected_schedule = []
    }

  }

  edit(content: any, row: any) {
    this.new_sequence = row;
    this.new_sequence_name = row.name;
    // this.loadAllSchedule();
    console.log("seqq : ", this.new_sequence_name, row.schedule);
    this.formAction = "edit";
    this.modalRef = this.modalService.open(content, { size: 'md', scrollable: true, centered: true })
  }


  // fnResetPassword(content: any, element: any) {
  //   this.selectedRecord = element;
  //   console.log(element)
  //   this.modalService.open(content, { size: 'md', scrollable: false })
  // }

  // saveNewPassword() {
  //   if (this.newPassword != "") {
  //     this.isLoading = true;
  //     let param = {
  //       password: this.newPassword,
  //       user_id: this.selectedRecord.user_id,
  //       client_id: this.selectedRecord.client_id
  //     }
  //     this.api.updateUser(param).subscribe({
  //       next: (res: any) => {
  //         this.loadData();
  //         this.modalService.dismissAll();
  //         this.isLoading = false;
  //         this.toast.success("Password Updated Successfully", 'Success')
  //       },
  //       error: (e: any) => {
  //         this.toast.error(e.error.msg, 'Error')
  //         this.isLoading = false;
  //       }
  //     })
  //   }
  //   else {
  //     this.toast.error("Password Field should not blank")
  //   }
  // }

  // saveUser(isValid: any) {
  //   this.isSubmitted = true;
  //   if (isValid) {
  //     let user_sign: any[] = [];
  //     this.signatures.forEach((element, index) => {
  //       user_sign.push({
  //         signature: element,
  //         isActive: index === this.selectedIndex ? true : false
  //       })
  //     }
  //     );
  //     console.log("user_sign", user_sign);
  //     this.isLoading = true;
  //     this.user.client_id = this.localStorage.getClientId();
  //     this.user.center_id = this.localStorage.getCenterId();
  //     this.user.user_sign = user_sign;
  //     //add dept id
  //     if (this.formAction == 'add') {
  //       this.api.createUser(this.user).subscribe({
  //         next: (res) => {
  //           this.loadData();
  //           this.isLoading = false;
  //           this.modalService.dismissAll();
  //           this.toast.success("User Added Successfully", 'Success')
  //         },
  //         error: (e) => {
  //           this.isLoading = false;
  //           console.log(e)
  //           this.toast.error(e?.error, 'Error')
  //         }
  //       })
  //     }
  //     else {
  //       this.api.updateUser(this.user).subscribe({
  //         next: (res: any) => {
  //           this.loadData();
  //           localStorage.setItem('user_sign', JSON.stringify(user_sign));
  //           this.modalService.dismissAll();
  //           this.isLoading = false;
  //           this.toast.success("User Updated Successfully", 'Success')
  //         },
  //         error: (e: any) => {
  //           this.toast.error(e.error.msg, 'Error')
  //           this.isLoading = false;
  //         }
  //       })
  //     }
  //   }
  // }


  // openSignatureModal(
  //   content: any,
  // ) {

  //   if (this.signatures.length >= 3) {
  //     this.toast.error('You can add only 3 signatures');
  //     return;
  //   }

  //   this.modalService.open(content, {
  //     size: 'lg',
  //     scrollable: true,
  //     centered: true,
  //   });
  // }

  // previewSignature(index: number) {
  //   this.selectedIndex = index;
  // }

  // selectSignature(index: number) {
  //   this.selectedIndex = index;
  // }

  handleModalClose(event: boolean) {
  }

  updateSignatures(updatedSignatures: any) {
    console.log("updatedSIngature", updatedSignatures);
    this.signatures.push(updatedSignatures[0]);
  }

  deleteSignature(index: number) {
    this.signatures.splice(index, 1);
  }

  previewSignatureModal(content: any, selectedIndex: number | null) {
    this.selectedIndex = selectedIndex;
    this.modalService.open(content, {
      size: 'lg',
      scrollable: true,
      centered: true,
    });
  }

  activateSequence(element: any) {
    // console.log("element slide : ",element);
    // if(element.status == true) {
    //   console.log("enabled : ")
    // }
    let param = {
      id: element.id,
      client_id: this.localStorage.getClientId(),
      status: element.status
    }
    console.log("element slide2 : ", param);
    this.sequenceApi.updateSequence(param).subscribe({
      next: (res: any) => {
        this.tracker.track(
          'Update',
          'Sequence Activation',
          `Changed status of sequence ID ${param.id} to ${param.status}`
        );
        console.log("roles :", res);
      }
    })
  }

  goToSequence(item: any) {
    console.log("name : ", item.name);
    localStorage.setItem('sequence_name', item.name);
    localStorage.setItem('sequence_selected', JSON.stringify(item));

    this.tracker.track(
      'Navigate',
      'Sequence View',
      `Opened sequence view for "${item.name}" (ID: ${item.id})`
    );
    this.router.navigate(['/main/sequence', item.id]);
  }

  getContactGroup() {
    this.isLoading = true;
    let param = {
      "where": {
        "client_id": this.localStorage.getClientId()
      }
    }
    // if(this.dateQuery.value){param = {...param,...this.dateQuery.value}}
    this.contactApi.getAllContactGroups(param).subscribe({
      next: (res: any) => {
        console.log("campaignList data :", res);
        this.isLoading = false;
        this.contactGroups = res || {};
      },
      error(err) {
        console.log("err : ", err);
      },
    })
  }

  openSchedule(content: any) {
    // this.addSequence?.close();
    this.addSschedule = this.offcanvasService.open(content, { position: 'end' });
  }

  save() { }

  loadAllSchedule() {
    this.slelectLoading = false;
    let param = {
      where: {
        client_id: parseInt(this.localStorage.getClientId())
      }
    }
    this.sequenceApi.getAllSequenceSchedule(param).subscribe({
      next: (res: any) => {
        console.log("roles :", res)
        this.slelectLoading = true;
        this.schedules = res;
      }
    })
  }

  handleUpdateData() {
    this.loadAllSequence();
  }

  loadAllSequence() {

    try {
      // Reset paginator to page 0 on sort change
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

      // Combine search, sort, and pagination changes
      merge(
        this.searchQuery.valueChanges,
        this.dateQuery.valueChanges,
        this.sort.sortChange,
        this.paginator.page
      ).pipe(
        startWith({}), // Trigger initial load
        switchMap(() => {
          this.initialLoad = true;
          let params: any = {
            where: {
              client_id: parseInt(this.localStorage.getClientId())
            },
            page: this.paginator.pageIndex * this.paginator.pageSize,
            limit: this.paginator.pageSize,
            filter: this.searchQuery.value,
            order: {
              col: "updatedAt",
              dir: 'DESC',
            },
          };

          if (this.dateQuery.value) {
            params = { ...params, ...this.dateQuery.value };
          }

          if(!this.isAdmin) {
            params.where['created_by'] = this.localStorage.getUserId();
          }

          return this.sequenceApi.getAllSequenceWithCount(params)
            .pipe(catchError(() => observableOf(null)));
        }),
        map((response: any) => {
          if (!response) {
            this.initialLoad = false;
            return [];
          }
          this.totalRows = response.count;
          return response;
        })
      ).subscribe({
        next: (data) => {
          this.initialLoad = false;
          this.dataSource = data.rows || [];
          console.log("Data->rows", this.dataSource);
        },
        error: (err) => {
          this.initialLoad = false;
          console.error(err);
        },
        complete: () => {
          this.initialLoad = false;
        }
      });

    } catch (err) {
      this.isLoading = false;
      console.error(err);
    }
  }

  createSequenceSchedule() {

    if (this.schedule_name == null || this.schedule_name == "") {
      this.toast.error("Please enter schedule name", "Error");
      this.schedule_error = "Please enter schedule name";
      return;
    }

    // chcking for at least one time is selected
    if (this.sunday_first == "" && this.sunday_second == "" && this.monday_first == "" && this.monday_second == "" && this.tuesday_first == "" && this.tuesday_second == "" && this.wednesday_first == "" && this.wednesday_second == "" && this.thursday_first == "" && this.thursday_second == "" && this.friday_first == "" && this.friday_second == "" && this.saturday_first == "" && this.saturday_second == "") {
      this.toast.error("Please select at least one time for the schedule", "Error");
      this.schedule_error = "Please select at least one time for the schedule";
      return;

    }

    this.isLoadingSchedule = true;
    let param = {
      "name": this.schedule_name,
      "client_id": this.localStorage.getClientId(),
      "schedule": {
        "sunday": [this.sunday_first, this.sunday_second],
        "monday": [this.monday_first, this.monday_second],
        "tuesday": [this.tuesday_first, this.tuesday_second],
        "wednesday": [this.wednesday_first, this.wednesday_second],
        "thursday": [this.thursday_first, this.thursday_second],
        "friday": [this.friday_first, this.friday_second],
        "saturday": [this.saturday_first, this.sunday_second]
      }
    }
    this.sequenceApi.createSequenceSchedule(param).subscribe({
      next: (res: any) => {
        console.log("roles :", res);
        this.schedule_name = "";
        this.sunday_first = "";
        this.sunday_second = "";
        this.monday_first = "";
        this.monday_second = "";
        this.tuesday_first = "";
        this.tuesday_second = "";
        this.wednesday_first = "";
        this.wednesday_second = "";
        this.thursday_first = "";
        this.thursday_second = "";
        this.friday_first = "";
        this.friday_second = "";
        this.saturday_first = "";
        this.sunday_second = "";

        this.schedule_error = "";
        // this.loadAllSchedule();

        setTimeout(() => {
          this.isLoadingSchedule = false;
        }, 1000);

        this.addSschedule?.close();

        this.tracker.track(
          'Create',
          'Sequence Schedule',
          `Created schedule "${param.name}"`
        );
      },
      error: (e) => {
        this.isLoadingSchedule = false;
        this.toast.error("Error creating schedule: ");
      }
    })
  }

  createSequence() {
    console.log("this.sequence_schedule : ", this.schedules[Number(this.sequence_schedule)]?.id);

    if (!this.sequence_name || this.sequence_name.trim() === "") {
      this.toast.error("Missing details", "Error");
      return;
    }

    // if type ses then check current email exists in ses details verified email list
    // if (this.email_provider_type == 'SES') {
    //   alert(this.communication_preference_data.email)
    //   let verifiedEmails = [];
    //   verifiedEmails.push(this.sesDetails?.fromEmail);
    //   this.sesDetails?.other_emails?.forEach((element: any) => {
    //     verifiedEmails.push(element);
    //   });
    //   let currentEmail = this.localStorage.getEmail();
    //   if (!verifiedEmails.includes(currentEmail)) {
    //     this.toast.error(`The email ${currentEmail} is not verified in SES. Please contact your admin`, "Error");
    //     return;
    //   }
    // }

    let param = {
      name: this.sequence_name,
      client_id: this.localStorage.getClientId(),
      created_by: this.localStorage.getUserId(),
      from_email: this.communication_preference_data?.email,
      email_provider_type: this.email_provider_type,
      date: new Date(),
      status: false
    };

    this.isLoading = true;

    this.sequenceApi.createSequence(param).subscribe({
      next: (res: any) => {
        console.log("roles :", res);
        this.isLoading = false;
        this.schedule_name = "";
        this.sequence_schedule = "";
        this.addSequence?.close();
        this.toast.success("Sequence created Successfully", "Success");
        this.loadAllSequence();

        this.tracker.track(
          'Create',
          'Sequence',
          `Created sequence "${param.name}"`
        );
      },
      error: (e) => {
        this.isLoading = false;

        // Safely extract error message
        const errorMsg =
          e?.error?.msg ||
          e?.error?.message ||
          e?.message ||
          "Something went wrong. Please try again.";

        this.toast.error(errorMsg, "Error");
        console.error("Error creating sequence:", e);
      }
    });
  }


  updateSequence() {
    this.isLoading = true;
    let param = {
      id: this.new_sequence.id,
      name: this.new_sequence_name,
      "client_id": this.localStorage.getClientId(),
      // "schedule_id": this.new_sequence.schedule_id,
      // "schedule": {
      //   "sunday": [this.sunday_first,this.sunday_second],
      //   "monday": [this.monday_first,this.monday_second],
      //   "tuesday": [this.tuesday_first, this.tuesday_second],
      //   "wednesday": [this.wednesday_first, this.wednesday_second],
      //   "thursday": [this.thursday_first, this.thursday_second],
      //   "friday": [this.friday_first, this.friday_second],
      //   "saturday": [this.saturday_first,this.sunday_second]
      // }
    }
    this.sequenceApi.updateSequence(param).subscribe({
      next: (res: any) => {
        console.log("roles :", res);
        this.new_sequence_name = "";
        this.new_sequence_schedule = "";

        this.tracker.track(
          'Update',
          'Sequence',
          `Updated sequence ID ${param.id} to new name "${param.name}"`
        );
        this.modalRef.close();       // ✅ close modal
        this.loadAllSequence();
      }
    })
  }

  getStatusText(element: any): string {
    // If completion is true, sequence is completed
    if (element.completion === true) {
      return 'Completed';
    }

    // If status is true (active) and not completed, it's running
    if (element.status === true) {
      return 'Running';
    }

    // If status is false and not completed, it's pending
    return 'Pending';
  }



  deleteSequence() {
    if (!this.new_sequence || !this.new_sequence.id) {
      this.toast.error("No sequence selected for deletion", "Error");
      return;
    }

    this.isLoading = true;

    const param = {
      id: this.new_sequence.id,
      client_id: this.localStorage.getClientId()
    };

    this.sequenceApi.deleteSequence(param).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.toast.success("Sequence deleted Successfully", "Success");
        this.addSequence?.close();
        this.modalService.dismissAll();
        this.loadAllSequence();
        this.tracker.track(
          'Delete',
          'Sequence',
          `Deleted sequence ID ${param.id}`
        );
      },
      error: (e: any) => {
        this.isLoading = false;
        this.toast.error("Error deleting sequence", "Error");
        console.error("Error deleting sequence:", e);
      }
    });
  }

  selectedSquence: any = null;
  runSequenceProceed = false;

  runSequence(content: any, row: any) {
    this.selectedSquence = row;
    this.runSequenceProceed = false;
    this.modalService.open(content, { size: 'md', scrollable: true, centered: true })
  }

  pauseSequence(element: any, row: any) {
    this.selectedSquence = row;
    this.modalService.open(element, { size: 'md', scrollable: true, centered: true })
  }

  runSequenceNow() {
    if (!this.selectedSquence || !this.selectedSquence.id) {
      this.toast.error("No sequence selected to run", "Error");
      return;
    }

    this.isLoading = true;

    const param = {
      id: this.selectedSquence.id,
      client_id: this.localStorage.getClientId(),
      status: true
    };

    this.sequenceApi.updateSequence(param).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.runSequenceProceed = false;
        this.toast.success("Sequence started Successfully", "Success");
        this.modalService.dismissAll();
        this.loadAllSequence();
        this.tracker.track(
          'Update',
          'Sequence',
          `Started sequence ID ${param.id}`
        );
      },
      error: (e: any) => {
        this.isLoading = false;
        this.toast.error("Error starting sequence", "Error");
        console.error("Error starting sequence:", e);
      }
    });
  }

  pauseSequenceNow() {
    if (!this.selectedSquence || !this.selectedSquence.id) {
      this.toast.error("No sequence selected to pause", "Error");
      return;
    }

    this.isLoading = true;

    const param = {
      id: this.selectedSquence.id,
      client_id: this.localStorage.getClientId(),
      status: false
    };

    this.sequenceApi.updateSequence(param).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.toast.success("Sequence paused Successfully", "Success");
        this.modalService.dismissAll();
        this.loadAllSequence();
        this.tracker.track(
          'Update',
          'Sequence',
          `Paused sequence ID ${param.id}`
        );
      },
      error: (e: any) => {
        this.isLoading = false;
        this.toast.error("Error pausing sequence", "Error");
        console.error("Error pausing sequence:", e);
      }
    });
  }


}

function observableOf(arg0: null): any {
  throw new Error('Function not implemented.');
}

export class User {
  user_id!: Number;
  prefix: string = "";
  fname: string = "";
  lname: string = "";
  email: string = "";
  password!: JSON;
  username: String = "";
  gender: String = "";
  picture: String = "";
  profile: String = "";
  twoFactorAuthentication: String = "";
  status: String = "";
  // client_id:String = "";
  client_id: Number = 0;
  center_id: Number = 0;
  dept_id: Number = 0;
  role_id: Number = 0;
  user_sign: any[] = [];
}
